import Vue from 'vue';
import { Money, isValidObject } from '@razlet/utils';

export default class Fop {
  uniqueKey = Date.now() + Math.random();

  id = null;

  applicability = [];

  label = null;

  changeable = false;

  required = false;

  client = '';

  clientEn = '';

  clientName = '';

  method = '';

  metadata = {};

  price = null;

  value = null;

  constructor (data) {
    if (!isValidObject(data)) return;

    this.id = data.id;
    this.client = data.client || data.clientCode;
    this.clientEn = data.clientEn;
    this.clientName = data.clientName || '-';
    this.applicability = data.applicability;
    this.changeable = data.changeable;
    this.label = data.label;
    this.required = data.required;
    this.method = data.method || data.payMethod;
    this.metadata = data.metadata || { value: data.payValue };

    this.value = data.value;

    if (data.price) this.price = new Money(data.price, { fractionDigits: 2 });
  }

  get payValue () {
    return this.metadata.value;
  }

  get localizedPaymentMethod () {
    if (!this.method) return '';
    return Vue.prototype.$localize.t(`shipments.info.paymentMethods.${this.method}`);
  }

  get isFilled () {
    return (
      !!this.method &&
      !!this.metadata.value
    );
  }

  get formattedValue () {
    if (!this.method) return '';
    if (this.method === 'CA') return `${this.localizedPaymentMethod} ${this.method}`;
    return `${this.client} ${this.method}`;
  }

  get formattedLabel () {
    if (!this.method) return '';
    if (this.method === 'CA') return `${this.localizedPaymentMethod} ${this.method}`;
    return `${this.client} ${this.clientName} ${this.method}`;
  }

  get fullName () {
    return this.formattedLabel;
  }
}
